import { render, staticRenderFns } from "./limittxt.vue?vue&type=template&id=50a8cd47&scoped=true&"
import script from "./limittxt.vue?vue&type=script&lang=js&"
export * from "./limittxt.vue?vue&type=script&lang=js&"
import style0 from "./limittxt.vue?vue&type=style&index=0&id=50a8cd47&prod&lang=scss&"
import style1 from "./limittxt.vue?vue&type=style&index=1&id=50a8cd47&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a8cd47",
  null
  
)

export default component.exports